import ButtonLink from '@/components/atoms/ButtonLink/ButtonLink';
import Image from 'next/image';
import { FC } from 'react';

interface ShopCardProps {
  variant: 'used' | 'new';
}

export const ShopCard: FC<ShopCardProps> = ({ variant }) => {
  const config =
    variant === 'used'
      ? {
          title: 'Shop pre-owned EVs',
          subtitle: 'Used vehicles from trusted dealerships.',
          buttonLabel: 'Shop used',
          buttonHref: '/used-cars',
          desktopImg: '/images/homepage/ListingCardsDesktop.webp',
          mobileImg: '/images/homepage/ListingCardsMobile.webp',
          alt: 'Used EVs',
        }
      : {
          title: 'Shop new EVs',
          subtitle: 'Search new vehicles for sale',
          buttonLabel: 'Shop new',
          buttonHref: '/new-cars',
          desktopImg: '/images/homepage/ShopNewCardsDesktop.webp',
          mobileImg: '/images/homepage/ShopNewCardsMobile.webp',
          alt: 'New EVs',
        };

  return (
    <div className="relative flex min-h-[455px] w-full overflow-hidden rounded-medium border border-neutral-200 bg-gradient-to-br from-neutral-0 to-[#0edab533]">
      <div className="z-10 flex h-full w-full flex-col justify-between p-[32px]">
        <div className="flex w-full flex-col gap-s [@media(min-width:450px)_and_(max-width:540px)]:w-[220px] [@media(min-width:750px)_and_(max-width:1200px)]:w-[200px]">
          <div className="flex text-h2SemiBold text-neutral-900">
            {config.title}
          </div>
          <div className="text-body1Regular text-neutral-800">
            {config.subtitle}
          </div>
        </div>
        <div className="flex w-fit-content">
          <ButtonLink
            aria-label={config.buttonLabel}
            theme="dark"
            href={config.buttonHref}
          >
            {config.buttonLabel}
          </ButtonLink>
        </div>
      </div>
      <div className="pointer-events-none absolute top-[10px] z-0 hidden m:right-[-220px] m:flex ml:right-[-120px] ml:top-[10px] l:right-[-50px] [@media(min-width:1018px)_and_(max-width:1150px)]:right-[-200px] [@media(min-width:450px)_and_(max-width:510px)]:right-[-280px] [@media(min-width:450px)_and_(max-width:510px)]:scale-75 [@media(min-width:740px)_and_(max-width:910px)]:right-[-230px] [@media(min-width:740px)_and_(max-width:910px)]:scale-75">
        <Image
          src={config.desktopImg}
          alt={config.alt}
          width={481}
          height={436}
          priority
        />
      </div>
      <div className="pointer-events-none absolute right-[-200px] top-[10px] z-0 flex scale-[55%] s:right-[-120px] s:scale-[75%] m:hidden [@media(min-width:450px)_and_(max-width:510px)]:scale-[45%]">
        <Image
          src={config.mobileImg}
          alt={config.alt}
          width={481}
          height={436}
          priority
        />
      </div>
    </div>
  );
};
